import { useQuery } from "@tanstack/react-query";
import { useUnmatchedDataApiClient } from "../../../../../hooks";
import { ROUTES } from "../../../../../routes";
import { DataPointDisplay } from "../../../../Emissions/DataPointDisplay";
import { useMapData } from "../../../hooks/mapDataAndFilters";
import { SidebarSection } from "../../../ui/SidebarItems";

export const UnmatchedDataPointDetailsTab = () => {
    const { selectedContext } = useMapData("mainMap");
    const apiClient = useUnmatchedDataApiClient();

    // No retrieve-by-id endpoint exists, so filter the list down to one id.
    const dataPointQuery = useQuery({
        queryKey: ["unmatchedDataPoint", selectedContext.unmatchedDataPointId],
        queryFn: async () => {
            const response = await apiClient.unmatchedDataPointsList({
                ids: [selectedContext.unmatchedDataPointId],
            });
            return response.results[0] ?? null;
        },
        enabled: !!selectedContext.unmatchedDataPointId,
    });

    return (
        <div className="w-[400px] h-full bg-white">
            <SidebarSection
                title="Properties"
                loading={dataPointQuery.isLoading}
                action={{
                    label: "Manage Detection",
                    fn: () => {
                        window.open(
                            `${ROUTES.DASHBOARD_UNMATCHED_DATA}?dataPoint=${dataPointQuery.data?.id}`,
                            "_blank",
                        );
                    },
                }}
            >
                <DataPointDisplay dataPoint={dataPointQuery.data} />
            </SidebarSection>
        </div>
    );
};
